import { render } from "./DashboardLayout.vue?vue&type=template&id=4977e71c&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=4977e71c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4977e71c"],['__file',"src/layout/DashboardLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4977e71c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4977e71c', __exports__)) {
    api.reload('4977e71c', __exports__)
  }
  
  module.hot.accept("./DashboardLayout.vue?vue&type=template&id=4977e71c&scoped=true", () => {
    api.rerender('4977e71c', render)
  })

}


export default __exports__